const PRIORITY_COLOURS = [
  {
    name: "secondary-red",
    priorities: [
      {
        bgColour: "bg-secondary-red-100",
        textColour: "!text-secondary-red-600",
        cardBorderColour: "border-l-secondary-red-100",
        eventBorderColour: "!border-secondary-red-100",
      },
      {
        bgColour: "bg-secondary-red-200",
        textColour: "!text-secondary-red-700",
        cardBorderColour: "border-l-secondary-red-200",
        eventBorderColour: "!border-secondary-red-200",
      },
      {
        bgColour: "bg-secondary-red-300",
        textColour: "!text-secondary-red-50",
        cardBorderColour: "border-l-secondary-red-300",
        eventBorderColour: "!border-secondary-red-300",
      },
      {
        bgColour: "bg-secondary-red-400",
        textColour: "!text-secondary-red-50",
        cardBorderColour: "border-l-secondary-red-400",
        eventBorderColour: "!border-secondary-red-400",
      },
      {
        bgColour: "bg-secondary-red-500",
        textColour: "!text-secondary-red-50",
        cardBorderColour: "border-l-secondary-red-500",
        eventBorderColour: "!border-secondary-red-500",
      },
      {
        bgColour: "bg-secondary-red-600",
        textColour: "!text-secondary-red-50",
        cardBorderColour: "border-l-secondary-red-600",
        eventBorderColour: "!border-secondary-red-600",
      },
      {
        bgColour: "bg-secondary-red-700",
        textColour: "!text-secondary-red-50",
        cardBorderColour: "border-l-secondary-red-700",
        eventBorderColour: "!border-secondary-red-700",
      },
      {
        bgColour: "bg-secondary-red-800",
        textColour: "!text-secondary-red-50",
        cardBorderColour: "border-l-secondary-red-800",
        eventBorderColour: "!border-secondary-red-800",
      },
      {
        bgColour: "bg-secondary-red-900",
        textColour: "!text-secondary-red-50",
        cardBorderColour: "border-l-secondary-red-900",
        eventBorderColour: "!!border-secondary-red-900",
      },
    ],
  },
  {
    name: "secondary-green",
    priorities: [
      {
        bgColour: "bg-secondary-green-100",
        textColour: "!text-secondary-green-800",
        cardBorderColour: "border-l-secondary-green-100",
        eventBorderColour: "!border-secondary-green-100",
      },
      {
        bgColour: "bg-secondary-green-200",
        textColour: "!text-secondary-green-900",
        cardBorderColour: "border-l-secondary-green-200",
        eventBorderColour: "!border-secondary-green-200",
      },
      {
        bgColour: "bg-secondary-green-300",
        textColour: "!text-secondary-green-50",
        cardBorderColour: "border-l-secondary-green-300",
        eventBorderColour: "!border-secondary-green-300",
      },
      {
        bgColour: "bg-secondary-green-400",
        textColour: "!text-secondary-green-50",
        cardBorderColour: "border-l-secondary-green-400",
        eventBorderColour: "!border-secondary-green-400",
      },
      {
        bgColour: "bg-secondary-green-500",
        textColour: "!text-secondary-green-50",
        cardBorderColour: "border-l-secondary-green-500",
        eventBorderColour: "!border-secondary-green-500",
      },
      {
        bgColour: "bg-secondary-green-600",
        textColour: "!text-secondary-green-50",
        cardBorderColour: "border-l-secondary-green-600",
        eventBorderColour: "!border-secondary-green-600",
      },
      {
        bgColour: "bg-secondary-green-700",
        textColour: "!text-secondary-green-50",
        cardBorderColour: "border-l-secondary-green-700",
        eventBorderColour: "!border-secondary-green-700",
      },
      {
        bgColour: "bg-secondary-green-800",
        textColour: "!text-secondary-green-50",
        cardBorderColour: "border-l-secondary-green-800",
        eventBorderColour: "!border-secondary-green-800",
      },
      {
        bgColour: "bg-secondary-green-900",
        textColour: "!text-secondary-green-50",
        cardBorderColour: "border-l-secondary-green-900",
        eventBorderColour: "!border-secondary-green-900",
      },
    ],
  },
  {
    name: "secondary-blue",
    priorities: [
      {
        bgColour: "bg-secondary-blue-100",
        textColour: "!text-secondary-blue-700",
        cardBorderColour: "border-l-secondary-blue-100",
        eventBorderColour: "!border-secondary-blue-100",
      },
      {
        bgColour: "bg-secondary-blue-200",
        textColour: "!text-secondary-blue-800",
        cardBorderColour: "border-l-secondary-blue-200",
        eventBorderColour: "!border-secondary-blue-200",
      },
      {
        bgColour: "bg-secondary-blue-300",
        textColour: "!text-white",
        cardBorderColour: "border-l-secondary-blue-300",
        eventBorderColour: "!border-secondary-blue-300",
      },
      {
        bgColour: "bg-secondary-blue-400",
        textColour: "!text-secondary-blue-50",
        cardBorderColour: "border-l-secondary-blue-400",
        eventBorderColour: "!border-secondary-blue-400",
      },
      {
        bgColour: "bg-secondary-blue-500",
        textColour: "!text-secondary-blue-50",
        cardBorderColour: "border-l-secondary-blue-500",
        eventBorderColour: "!border-secondary-blue-500",
      },
      {
        bgColour: "bg-secondary-blue-600",
        textColour: "!text-secondary-blue-50",
        cardBorderColour: "border-l-secondary-blue-600",
        eventBorderColour: "!border-secondary-blue-600",
      },
      {
        bgColour: "bg-secondary-blue-700",
        textColour: "!text-secondary-blue-50",
        cardBorderColour: "border-l-secondary-blue-700",
        eventBorderColour: "!border-secondary-blue-700",
      },
      {
        bgColour: "bg-secondary-blue-800",
        textColour: "!text-secondary-blue-50",
        cardBorderColour: "border-l-secondary-blue-800",
        eventBorderColour: "!border-secondary-blue-800",
      },
      {
        bgColour: "bg-secondary-blue-900",
        textColour: "!text-secondary-blue-50",
        cardBorderColour: "border-l-secondary-blue-900",
        eventBorderColour: "!border-secondary-blue-900",
      },
    ],
  },
  {
    name: "secondary-brown",
    priorities: [
      {
        bgColour: "bg-secondary-brown-100",
        textColour: "!text-secondary-brown-800",
        cardBorderColour: "border-l-secondary-brown-100",
        eventBorderColour: "!border-secondary-brown-100",
      },
      {
        bgColour: "bg-secondary-brown-200",
        textColour: "!text-white",
        cardBorderColour: "border-l-secondary-brown-200",
        eventBorderColour: "!border-secondary-brown-200",
      },
      {
        bgColour: "bg-secondary-brown-300",
        textColour: "!text-secondary-brown-50",
        cardBorderColour: "border-l-secondary-brown-300",
        eventBorderColour: "!border-secondary-brown-300",
      },
      {
        bgColour: "bg-secondary-brown-400",
        textColour: "!text-secondary-brown-50",
        cardBorderColour: "border-l-secondary-brown-400",
        eventBorderColour: "!border-secondary-brown-400",
      },
      {
        bgColour: "bg-secondary-brown-500",
        textColour: "!text-secondary-brown-50",
        cardBorderColour: "border-l-secondary-brown-500",
        eventBorderColour: "!border-secondary-brown-500",
      },
      {
        bgColour: "bg-secondary-brown-600",
        textColour: "!text-secondary-brown-50",
        cardBorderColour: "border-l-secondary-brown-600",
        eventBorderColour: "!border-secondary-brown-600",
      },
      {
        bgColour: "bg-secondary-brown-700",
        textColour: "!text-secondary-brown-50",
        cardBorderColour: "border-l-secondary-brown-700",
        eventBorderColour: "!border-secondary-brown-700",
      },
      {
        bgColour: "bg-secondary-brown-800",
        textColour: "!text-secondary-brown-50",
        cardBorderColour: "border-l-secondary-brown-800",
        eventBorderColour: "!border-secondary-brown-800",
      },
      {
        bgColour: "bg-secondary-brown-900",
        textColour: "!text-secondary-brown-50",
        cardBorderColour: "border-l-secondary-brown-900",
        eventBorderColour: "!border-secondary-brown-900",
      },
    ],
  },
  {
    name: "secondary-fuschia",
    priorities: [
      {
        bgColour: "bg-secondary-fuschia-100",
        textColour: "!text-secondary-fuschia-800",
        cardBorderColour: "border-l-secondary-fuschia-100",
        eventBorderColour: "!border-secondary-fuschia-100",
      },
      {
        bgColour: "bg-secondary-fuschia-200",
        textColour: "!text-secondary-fuschia-900",
        cardBorderColour: "border-l-secondary-fuschia-200",
        eventBorderColour: "!border-secondary-fuschia-200",
      },
      {
        bgColour: "bg-secondary-fuschia-300",
        textColour: "!text-white",
        cardBorderColour: "border-l-secondary-fuschia-300",
        eventBorderColour: "!border-secondary-fuschia-300",
      },
      {
        bgColour: "bg-secondary-fuschia-400",
        textColour: "!text-secondary-fuschia-50",
        cardBorderColour: "border-l-secondary-fuschia-400",
        eventBorderColour: "!border-secondary-fuschia-400",
      },
      {
        bgColour: "bg-secondary-fuschia-500",
        textColour: "!text-secondary-fuschia-50",
        cardBorderColour: "border-l-secondary-fuschia-500",
        eventBorderColour: "!border-secondary-fuschia-500",
      },
      {
        bgColour: "bg-secondary-fuschia-600",
        textColour: "!text-secondary-fuschia-50",
        cardBorderColour: "border-l-secondary-fuschia-600",
        eventBorderColour: "!border-secondary-fuschia-600",
      },
      {
        bgColour: "bg-secondary-fuschia-700",
        textColour: "!text-secondary-fuschia-50",
        cardBorderColour: "border-l-secondary-fuschia-700",
        eventBorderColour: "!border-secondary-fuschia-700",
      },
      {
        bgColour: "bg-secondary-fuschia-800",
        textColour: "!text-secondary-fuschia-50",
        cardBorderColour: "border-l-secondary-fuschia-800",
        eventBorderColour: "!border-secondary-fuschia-800",
      },
      {
        bgColour: "bg-secondary-fuschia-900",
        textColour: "!text-secondary-fuschia-50",
        cardBorderColour: "border-l-secondary-fuschia-900",
        eventBorderColour: "!border-secondary-fuschia-900",
      },
    ],
  },
  {
    name: "secondary-teal",
    priorities: [
      {
        bgColour: "bg-secondary-teal-100",
        textColour: "!text-secondary-teal-700",
        cardBorderColour: "border-l-secondary-teal-100",
        eventBorderColour: "!border-secondary-teal-100",
      },
      {
        bgColour: "bg-secondary-teal-200",
        textColour: "!text-secondary-teal-800",
        cardBorderColour: "border-l-secondary-teal-200",
        eventBorderColour: "!border-secondary-teal-200",
      },
      {
        bgColour: "bg-secondary-teal-300",
        textColour: "!text-white",
        cardBorderColour: "border-l-secondary-teal-300",
        eventBorderColour: "!border-secondary-teal-300",
      },
      {
        bgColour: "bg-secondary-teal-400",
        textColour: "!text-secondary-teal-50",
        cardBorderColour: "border-l-secondary-teal-400",
        eventBorderColour: "!border-secondary-teal-400",
      },
      {
        bgColour: "bg-secondary-teal-500",
        textColour: "!text-secondary-teal-50",
        cardBorderColour: "border-l-secondary-teal-500",
        eventBorderColour: "!border-secondary-teal-500",
      },
      {
        bgColour: "bg-secondary-teal-600",
        textColour: "!text-secondary-teal-50",
        cardBorderColour: "border-l-secondary-teal-600",
        eventBorderColour: "!border-secondary-teal-600",
      },
      {
        bgColour: "bg-secondary-teal-700",
        textColour: "!text-secondary-teal-50",
        cardBorderColour: "border-l-secondary-teal-700",
        eventBorderColour: "!border-secondary-teal-700",
      },
      {
        bgColour: "bg-secondary-teal-800",
        textColour: "!text-secondary-teal-50",
        cardBorderColour: "border-l-secondary-teal-800",
        eventBorderColour: "!border-secondary-teal-800",
      },
      {
        bgColour: "bg-secondary-teal-900",
        textColour: "!text-secondary-teal-50",
        cardBorderColour: "border-l-secondary-teal-900",
        eventBorderColour: "!border-secondary-teal-900",
      },
    ],
  },
  {
    name: "secondary-purple",
    priorities: [
      {
        bgColour: "bg-secondary-purple-100",
        textColour: "!text-secondary-purple-800",
        cardBorderColour: "border-l-secondary-purple-100",
        eventBorderColour: "!border-secondary-purple-100",
      },
      {
        bgColour: "bg-secondary-purple-200",
        textColour: "!text-white",
        cardBorderColour: "border-l-secondary-purple-200",
        eventBorderColour: "!border-secondary-purple-200",
      },
      {
        bgColour: "bg-secondary-purple-300",
        textColour: "!text-white",
        cardBorderColour: "border-l-secondary-purple-300",
        eventBorderColour: "!border-secondary-purple-300",
      },
      {
        bgColour: "bg-secondary-purple-400",
        textColour: "!text-secondary-purple-50",
        cardBorderColour: "border-l-secondary-purple-400",
        eventBorderColour: "!border-secondary-purple-400",
      },
      {
        bgColour: "bg-secondary-purple-500",
        textColour: "!text-secondary-purple-50",
        cardBorderColour: "border-l-secondary-purple-500",
        eventBorderColour: "!border-secondary-purple-500",
      },
      {
        bgColour: "bg-secondary-purple-600",
        textColour: "!text-secondary-purple-50",
        cardBorderColour: "border-l-secondary-purple-600",
        eventBorderColour: "!border-secondary-purple-600",
      },
      {
        bgColour: "bg-secondary-purple-700",
        textColour: "!text-secondary-purple-50",
        cardBorderColour: "border-l-secondary-purple-700",
        eventBorderColour: "!border-secondary-purple-700",
      },
      {
        bgColour: "bg-secondary-purple-800",
        textColour: "!text-secondary-purple-50",
        cardBorderColour: "border-l-secondary-purple-800",
        eventBorderColour: "!border-secondary-purple-800",
      },
      {
        bgColour: "bg-secondary-purple-900",
        textColour: "!text-secondary-purple-50",
        cardBorderColour: "border-l-secondary-purple-900",
        eventBorderColour: "!border-secondary-purple-900",
      },
    ],
  },
  {
    name: "secondary-cyan",
    priorities: [
      {
        bgColour: "bg-secondary-cyan-100",
        textColour: "!text-secondary-cyan-800",
        cardBorderColour: "border-l-secondary-cyan-100",
        eventBorderColour: "!border-secondary-cyan-100",
      },
      {
        bgColour: "bg-secondary-cyan-200",
        textColour: "!text-white",
        cardBorderColour: "border-l-secondary-cyan-200",
        eventBorderColour: "!border-secondary-cyan-200",
      },
      {
        bgColour: "bg-secondary-cyan-300",
        textColour: "!text-white",
        cardBorderColour: "border-l-secondary-cyan-300",
        eventBorderColour: "!border-secondary-cyan-300",
      },
      {
        bgColour: "bg-secondary-cyan-400",
        textColour: "!text-secondary-cyan-50",
        cardBorderColour: "border-l-secondary-cyan-400",
        eventBorderColour: "!border-secondary-cyan-400",
      },
      {
        bgColour: "bg-secondary-cyan-500",
        textColour: "!text-secondary-cyan-50",
        cardBorderColour: "border-l-secondary-cyan-500",
        eventBorderColour: "!border-secondary-cyan-500",
      },
      {
        bgColour: "bg-secondary-cyan-600",
        textColour: "!text-secondary-cyan-50",
        cardBorderColour: "border-l-secondary-cyan-600",
        eventBorderColour: "!border-secondary-cyan-600",
      },
      {
        bgColour: "bg-secondary-cyan-700",
        textColour: "!text-secondary-cyan-50",
        cardBorderColour: "border-l-secondary-cyan-700",
        eventBorderColour: "!border-secondary-cyan-700",
      },
      {
        bgColour: "bg-secondary-cyan-800",
        textColour: "!text-secondary-cyan-50",
        cardBorderColour: "border-l-secondary-cyan-800",
        eventBorderColour: "!border-secondary-cyan-800",
      },
      {
        bgColour: "bg-secondary-cyan-900",
        textColour: "!text-secondary-cyan-50",
        cardBorderColour: "border-l-secondary-cyan-900",
        eventBorderColour: "!border-secondary-cyan-900",
      },
    ],
  },
]

export function createGetColour() {
  const colours = PRIORITY_COLOURS.slice()
  const defaultColour = colours.shift()
  const colourMap = new Map<string, typeof defaultColour>()

  return function getColour(
    uniqueId: string,
    index: number,
    numberOfOptions: number,
  ) {
    if (!colourMap.has(uniqueId)) {
      colourMap.set(uniqueId, colours.shift() || defaultColour)
    }

    const classColours = colourMap.get(uniqueId)!.priorities

    const shadeIndex = mostDistinct({
      start: 0,
      end: classColours.length - 1,
      numberOfOptions,
      index,
    })

    return classColours[shadeIndex] || classColours[classColours.length - 1]
  }
}

export type GetColours = ReturnType<typeof createGetColour>
export type Colours = ReturnType<GetColours>
function mostDistinct({
  start,
  end,
  numberOfOptions,
  index,
}: {
  start: number
  end: number
  numberOfOptions: number
  index: number
}) {
  if (numberOfOptions <= 1) return start

  if (numberOfOptions >= end) {
    return index
  }

  const step = (end - start) / (numberOfOptions - 1)
  return Math.floor(start + index * step)
}

export const neutralColour: Colours = {
  bgColour: "bg-neutral-300",
  textColour: "!text-neutral-600",
  cardBorderColour: "border-l-neutral-600",
  eventBorderColour: "!border-neutral-400",
}

const MAX_SHADES = 8
export function createGetSteppedColour() {
  const idMap = new Map<string, number>()
  return (id: string, rank: number) => {
    if (!idMap.has(id)) {
      const shade = Math.min(idMap.size * 2, MAX_SHADES)
      idMap.set(id, shade)
    }
    const shade = idMap.get(id)!

    return PRIORITY_COLOURS[rank].priorities[shade]
  }
}
export type GetSteppedColours = ReturnType<typeof createGetSteppedColour>
